import axios from "axios"
import {
  GET_HOLIDAY_JSON_PENDING,
  GET_HOLIDAY_JSON_FAILED,
  GET_HOLIDAY_JSON_FULFILLED,
} from "constants-lib/actionTypes"

export const pendingAC = () => ({
  type: GET_HOLIDAY_JSON_PENDING,
})

export const failedAC = (data) => ({
  type: GET_HOLIDAY_JSON_FAILED,
  payload: data,
})

export const fulfilledAC = (data) => ({
  type: GET_HOLIDAY_JSON_FULFILLED,
  payload: data,
})

export const getHolidayJson = () => (dispatch) => {
  let url = `/content/dam/wm/ecom/holidayApi.json`

  const mockOrigin = process.env.NEXT_PUBLIC_ORIGIN
  // ensure we properly mock the origin in local dev
  if (process.env.NEXT_PUBLIC_ORIGIN) {
    url = `${mockOrigin}/content/dam/wm/ecom/holidayApi.json`
  }

  dispatch(pendingAC())
  return axios
    .get(url)
    .then((response) => {
      dispatch(fulfilledAC(response.data))
      return response.data
    })
    .catch((error) => {
      dispatch(failedAC(error.response.status))
      return error.response.status
    })
}
